/**
 * Items API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import {
  createItem,
  deleteItem,
  getItems,
  permanentDeleteItem,
  restoreItem,
  updateItem,
} from "../generated/items/items";

import { wrapListMethod, wrapMethod } from "./utils";

export const items = {
  /** @see createItem */
  create: wrapMethod(createItem),

  /** @see getItems */
  list: wrapListMethod(getItems),

  /** @see updateItem */
  update: wrapMethod(updateItem),

  /** @see deleteItem */
  delete: wrapMethod(deleteItem),

  /** @see restoreItem */
  restoreItem: wrapMethod(restoreItem),

  /** @see permanentDeleteItem */
  permanentDeleteItem: wrapMethod(permanentDeleteItem),
} as const;

export type ItemsApi = typeof items;
